/**
 * Normalize HTTP-like status from various error shapes.
 * - Supports fetch/axios-like errors: error.status, error.response.status, error.cause.status
 * - Returns undefined when no finite status can be derived (treat as network/unknown)
 */
export const getStatus = (e: unknown): number | undefined => {
  const anyE = e as any;
  const s = Number(
    anyE?.status ?? anyE?.response?.status ?? anyE?.cause?.status,
  );
  return Number.isFinite(s) ? s : undefined;
};
